import { AutoComplete } from 'primereact/autocomplete';
import { useRef, useState } from 'react';
import { privateFetch } from '../../utils/apiHelper';
import { useAccountContext } from '../../contexts/AccountContext';

function CityAutocomplete({ setSelectedPlace, placeQuery, setPlaceQuery }) {
  const autocompleteRef = useRef(null);
  const { accountContext } = useAccountContext();
  const [placeList, setPlaceList] = useState([]);

  const fetchPlaceList = async () => {
    await privateFetch(
      'GET',
      'resources',
      `/cu/${accountContext.id}/address/autocomplete/?query=${placeQuery}`
    ).then((res) => {
      setPlaceList(res);
    });
  };

  const addressTemplate = (item) => {
    return <div>{`${item.name}`}</div>;
  };

  return (
    <AutoComplete
      ref={autocompleteRef}
      field="name"
      inputClassName="autocomplete-input"
      value={placeQuery}
      suggestions={placeList}
      completeMethod={fetchPlaceList}
      onChange={(e) => {
        setPlaceQuery(e.value);
        setSelectedPlace(undefined);
      }}
      onSelect={(e) => {
        setSelectedPlace(e.value);
      }}
      itemTemplate={addressTemplate}
      placeholder="Veuillez sélectionner une ville"
    />
  );
}

export default CityAutocomplete;
